<div class="container">
    <h1>Not found</h1>
    <button class="btn btn-info btn-lg" [routerLink]="['/']">Return to the home page</button>
</div>